import React, { useEffect} from 'react'; // ✅ Ajout de useState
import "../ConnexionForm/forme.css";
import { useNavigate, useParams } from 'react-router-dom';
import allIcon from '../../image/allIcon.png';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Loader from 'components/Loader/Loader';
import { useActivationUserMutation } from 'actions/auth/mutations';
//import { LOGIN_PATH } from 'routes/navigation/navigationPaths';

export const Activation = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [activateUser] = useActivationUserMutation();

  /*const bounce = cssTransition({
    enter: "animate__animated animate__bounceIn",
    exit: "animate__animated animate__bounceOut",
  });*/

  useEffect(() => {
    const { uid, token } = params;
    console.log("🔍 uid reçu :", uid);
    console.log("🔍 token reçu :", token);

    const handleActivation = async () => {
      try {
        const data = { uid, token };
        const response = await activateUser(data).unwrap();
        console.log(response);
        
        toast.success("Votre compte a été activé !");
        setTimeout(() => navigate('/login'), 1000);
      } catch (error) {
        console.error('Erreur lors de la requête:', error);
        toast.error("Lien invalide ou expiré.");
      }
    };

    handleActivation();
  }, [params, navigate, activateUser]);

  /** 
  useEffect(() => {
    if (isRedirecting) {
      const timer = setTimeout(() => {
        <Loader />
        navigate(LOGIN_PATH);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isRedirecting, navigate]);
  **/

  return (
    <>
      <ToastContainer />
      <div className="row auth-wrapper">
        <div className="col-12 col-md-6 col-lg-6 auth-main-col text-center">
          <div className='mm'>
            <div
              style={{
                borderRadius: '200px',
                height: '200px',
                width: '200px',
                background: '#F8FAF5',
                margin: '0 auto'
              }}
            >
              <i className="i checkmark">✓</i>
            </div>
            <h1 className='h1'>Activation</h1>
            <p className='p'>Vérification en cours...</p>
          </div>
        </div>
        <div className="col-12 col-md-5 col-lg-6 auth-background-col">
          <div className="auth-background-holder">
            <div className="allIconImage">
              <img src={allIcon} className="img" />
            </div>
            <div className="text-bas">
              <h6>Easy compta</h6>
              <p>
                Easy Compta simplifie la gestion financière, vous permettant de suivre vos revenus et dépenses,
                générer des rapports détaillés et rester toujours en contrôle de votre comptabilité.
              </p>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};